import template from './sw-cms-el-preview-top-finder-selectboxes.html.twig';
import './sw-cms-el-preview-top-finder-selectboxes.scss';

export default {
    template,

    props: {
        element: {
            type: Object,
            required: true,
        },
    },
};
